<app-header [pageTitle]="pageTitle" (back)="backToLeaveSyndicate()"></app-header>
<ion-content>
  <div class="upper-content-wrapper">
    <p class="tom-syndicate">{{syndicateName}}</p>
  </div>
  <div class="lower-content-wrapper">
    <p class="emoji">💬</p>
    <p class="reason-heading">{{'something-else.else' | translate}}</p>
    <div class="reason-content leave-wrapper">
      <p [innerHTML]="'something-else.helpful' | translate"></p>
      <button class="blue-link" (click)="closeAndRedirect()">
        {{'something-else.help-centre' | translate}}
      </button>
    </div>
  </div>
  <ion-row class="lower-most-content">
    <ion-col class="still-leave-wrap">
      <p class="still-leave" (click)="leave()">{{'something-else.leave' | translate}}</p>
    </ion-col>
  </ion-row>
</ion-content>
